import React, {Fragment, useCallback} from 'react';

import {ExternalServicesTaggingEnum} from 'main/analytics/gaTagsEnum';
import {makeGetPerksClubLink} from 'main/factories/usecases';
import perksImgLg from 'presentation/assets/images/perks-club-lg.webp';
import perksImgSm from 'presentation/assets/images/perks-club-sm.webp';
import {AlertModal} from 'presentation/components';
import {useGetEndpointUrl} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {useExternalServiceStore} from 'presentation/pages/private/store/externalSerivceUrlStore';
import {translations} from 'presentation/translations-new';
import {PerksCard} from '../PerksCard';

const {perksClubDescription} = translations['pt-br'].privateFlow.perks;
const {perksClub} = translations['pt-br'].privateFlow.services;
const {serverError, unexpectedError, serverErrorTitle, tryAgain, learnMore} =
	translations['pt-br'].commons;

export function PerksClub() {
	const {isError, setIsError, getLink, isLoading} = useGetEndpointUrl(perksClub);
	const cachedURL = useExternalServiceStore(state => state.urls[perksClub]);

	const {isMobile} = useMediaQueries();
	const perksImg = isMobile ? perksImgSm : perksImgLg;

	const handleClick = useCallback(() => {
		if (cachedURL) {
			window.open(cachedURL);
			return;
		}
		getLink(makeGetPerksClubLink);
	}, [cachedURL]);

	return (
		<Fragment>
			<PerksCard
				cardImage={perksImg}
				description={perksClubDescription}
				title={perksClub}
				handleAction={handleClick}
				isLoading={isLoading}
				dataTagId={ExternalServicesTaggingEnum.CLICK_CLUBE_DE_VANTAGENS}
				buttonIcon="external-link-default"
				buttonText={learnMore}
			/>
			{isError ? (
				<AlertModal
					open={isError}
					onClose={() => setIsError(false)}
					description={serverError}
					title={serverErrorTitle}
					headerTitle={unexpectedError}
					buttonLabel={tryAgain}
					variant="info"
				/>
			) : null}
		</Fragment>
	);
}
